import { useEffect, useState } from "react";

//api
import { ProjectManagementService } from "../../../service/projectmanagement-service";

//components
import ReactMarkdown from 'react-markdown';
import { Dialog } from "primereact/dialog";

const ElaborationAnalysisFiles = ({projectId})=>{
    const [analysisFile, setAnalysisfile] = useState(null);
    const [markdownContent, setMarkdownContent] = useState('');
    const [previewVisible, setPreviewVisible] = useState(false);
    const [selectedFileForPreview, setSelectedFileForPreview] = useState(null);

    // GET per file analisi
    useEffect(()=>{
        const fetchProjectFiles = ()=>{
            if(projectId){
                ProjectManagementService.getProjectFiles(projectId, (data)=>{
                    if (data && Array.isArray(data.results.items)) {
                            setAnalysisfile(data.results.items);
                        } else if (Array.isArray(data)) {
                             
                             setAnalysisfile(data);
                        }
                        else {
                            console.error("API returned unexpected data structure for project files:", data);
                            setAnalysisfile([]);
                        }
                },
                (error)=>{
                    console.error("Errore durante il recupero dei file di analisi: ", error);
                    setAnalysisfile(null);
                })
            }
        };
        fetchProjectFiles();
    },[projectId])

    //anteprima pdf e md file analisi
    const handlePreview = (file) => {
        if (file) {
            if (file.file_type === 'pdf') {
                const downloadUrl = file.file_url;
                const fileName = file.name || 'download';
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            } else if (file.file_type === 'md') {
                const downloadUrl = file.file_url;
                const token = localStorage.getItem('token');
                ProjectManagementService.fetchMarkdownContent(
                downloadUrl,
                token,
                setMarkdownContent
                );
                setSelectedFileForPreview(file);
                setPreviewVisible(true);
            } else {
                console.log('Anteprima non disponibile per questo tipo di file.');
            }
        } else {
        console.log('File non trovato con ID:', file.id);
        }
    };

    const hidePreviewDialog = () => {
        setPreviewVisible(false);
        setMarkdownContent('');
        setSelectedFileForPreview(null);
    };

    return (
        <div  className="elaborationDetail__ProjectWrapper">
            {
                analysisFile ?
                analysisFile.map((file)=>(
                    <ul key={file.id} >
                        <div style={{display:'flex', flexDirection:'row'}}> 
                            <li  className="elaborationDetail__PreviewText" onClick={() => handlePreview(file)}>{file.name}</li> 
                        </div>
                    </ul>
                )) :null
            }
            {selectedFileForPreview && (
                <Dialog
                    header={`Anteprima ${selectedFileForPreview.name}`}
                    visible={previewVisible}
                    style={{ width: '80vw', height: '80vh' }}
                    onHide={hidePreviewDialog}
                    maximizable
                >
                    {selectedFileForPreview.file_type === 'md' ? (
                        <div
                            style={{
                                height: '100%',
                                overflowY: 'auto',
                                border: '1px solid #ccc',
                                padding: '10px',
                                backgroundColor: '#f9f9f9',
                            }}
                        >
                            <ReactMarkdown>{markdownContent}</ReactMarkdown>
                        </div>
                    ) : (
                        <p>
                            Anteprima non disponibile, questo tipo di file verrà scaricato.
                            Controlla nella cartella Download.
                        </p>
                    )}
                </Dialog>
            )}
        </div>
    )
}

export default ElaborationAnalysisFiles